import { defineMessages } from "react-intl";

export default defineMessages({
    hotAccessList: { id: "hot_accesses.hotAccessList", defaultMessage: "HOT ACCESS LIST", description: "HotAccesses: HOT ACCESS LIST" }
});